import linkViewModel from '@vimcar/mvvm/linkViewModel'
import IForm from '@vimcar/shared-components/components/IForm/'
import NumberField from '@vimcar/shared-components/components/IForm/components/NumberField'
import Paragraph from '@vimcar/shared-components/components/Paragraph'
import * as React from 'react'

import type { ViewState } from '../Root/viewModel'
import type { ViewModel } from './viewModel'

import i18n from '../../utils/i18n'
import BottomActions from '../BottomActions'
import StepContent from '../StepContent'
import styles from './styles.css'
import mkViewModel from './viewModel'

const tp = i18n.prefixWithoutTestId('CustomOdometerInput')

type Props = {
  state: ViewState
  optional: boolean
  viewModel: ViewModel
}

const CustomOdometerInput = ({ state, viewModel }: Props) => (
  <React.Fragment>
    <StepContent>
      <Paragraph variant='subtitle1'>{state.currentNode.text}</Paragraph>
      <Paragraph variant='body2'>{state.currentNode.subtext}</Paragraph>
      {/* @ts-expect-error@2322 */}
      <IForm
        className={styles.form}
        onChange={viewModel.handleFormChange}
        onValid={viewModel.handleFormValid}
      >
        <NumberField label={tp('odometer')} property='odometer' required />
      </IForm>
    </StepContent>
    <BottomActions
      // @ts-expect-error@2322
      extraButtons={viewModel.buttons}
      nextEnabled={viewModel.isValid}
      onBack={viewModel.handleBack}
      onNext={viewModel.handleNext}
      showBack
    />
  </React.Fragment>
)

// @ts-expect-error@2345
const component = linkViewModel(mkViewModel, CustomOdometerInput)
component.displayName = 'CustomOdometerInput'
export default component
